import React, { Component } from "react";
import SummaryCellWithStatusPanel from "../../shared/summaryRowCells/SummaryCellWithStatusPanel";
import CellWithTwoLabels from "../../shared/groups/CellWithTwoLabels";
import Contentify from "../../../content/Contentify";
import Store from "../../../content/Store";
import Tooltip from "../../shared/Tooltip";
import styles from "../../../assets/css/modules/claims/payment-details-row.css";
import formatCurrencyAmount from "./../../../helpers/FormatCurrencyAmount";

export class PaymentDetailsRow extends Component {
  static content = Store.PaymentDetails.row;

  getTooltipText = () => {
    let tooltipText = "";

    tooltipText = this.props.treatment.Shortfalls.map((shortfall) => (
      <React.Fragment>
        <h6>{shortfall.Reason}</h6>
        {this.props.treatment.IsCashBenefitAndHasShortfall ? null : (
          <p className="mb-3">
            {this.props.content.shortfallReasons[shortfall.Type]}
          </p>
        )}
      </React.Fragment>
    ));

    return tooltipText;
  };

  render() {
    return (
      <div className={styles.paymentDetailsRow}>
        <div className="row align-items-center text-center text-lg-left">
          <i
            className={
              styles.healthIcon + " icon-health-hand-cross display-4 col-lg-1"
            }
          />
          <div className="col-lg-5">
            <SummaryCellWithStatusPanel
              topLabel={this.props.treatment.Description}
              bottomLabel={[
                this.props.treatment.ProviderName,
                this.props.treatment.TreatmentStartDate
              ].join(" • ")}
              statusPanelText={
                this.props.treatment.HasShortfall
                  ? this.props.content.paymentNeededLabel
                  : this.props.content.costCoveredLabel
              }
              statusColour={this.props.treatment.HasShortfall ? "red" : "green"}
              hideStatusPanel={
                this.props.treatment.IsCashBenefitAndHasShortfall
              }
            />
          </div>
          <div className="costOfTreatment midRows col-lg-2">
            <CellWithTwoLabels
              topLabelStyleOverride={styles.topLabelStyle}
              bottomLabelStyleOverride={styles.bottomLabelStyle}
              topLabel={this.props.content.costOfTreatment}
              bottomLabel={formatCurrencyAmount(
                this.props.treatment.CostOfTreatment
              )}
            />
          </div>
          <div className="amountPaid midRows col-lg-2">
            <CellWithTwoLabels
              topLabelStyleOverride={styles.topLabelStyle}
              bottomLabelStyleOverride={styles.bottomLabelStyle}
              topLabel={this.props.content.amountPaidLabel}
              bottomLabel={formatCurrencyAmount(
                this.props.treatment.AmountCovered
              )}
            />
          </div>
          <div className="youNeedToPay midRows col-lg-2">
            <CellWithTwoLabels
              topLabelStyleOverride={styles.topLabelStyle}
              bottomLabelStyleOverride={
                styles.bottomLabelStyle + " " + styles.blueColourText
              }
              topLabel={this.props.content.youNeedToPayLabel}
              bottomLabel={formatCurrencyAmount(
                this.props.treatment.IsCashBenefitAndHasShortfall
                  ? 0
                  : this.props.treatment.MemberLiabilityAmount
              )}
            />
          </div>
          {this.props.treatment.HasShortfall ? (
            <div className="shortfallInfo offset-lg-1 col">
              <Tooltip text={this.getTooltipText()} />
            </div>
          ) : null}
        </div>
         {this.props.treatment.HasShortfall && !this.props.treatment.IsCashBenefitAndHasShortfall && this.props.treatment.MemberLiabilityAmount > 0 ? (
          <div className="row">
            <div className="col-lg-1"></div>
            <div className={"col-lg-11 "  + styles.NoDetailsHeld}>
                  <i className={"icon-info " + styles.cardIcon}/>   
                  <span>{Store.ClaimDetails.AlreadyPaidInfo}</span>
            </div>
          </div>):null}
        <div className={"col-12 " + styles.horizontalLine + " pt-2 mb-3"} />
      </div>
    );
  }
}

export default Contentify(PaymentDetailsRow);
